import { ClientInfo } from './constants/application';

export class LOGGER {
  public static readonly DEBUG_ENABLED: boolean = localStorage.getItem('portaljs_debug') === 'true';

  public static debug(message: string, ...args: any[]) {
    if (LOGGER.DEBUG_ENABLED) {
      console.debug(`[${ClientInfo.ID}] ${message}`, ...args);
    }
  }
}
